module.exports = __webpack_public_path__ + "static/image3-28e0901625f0d9dacadc206365793e04.jpg";